import { useForm } from 'react-hook-form'
import { FormObjectType, JoinOtpCertFormItemsType } from 'src/types/react-hook-form'
import { NumReplace, regExps } from 'src/utils/regExps_util'
const useOtpCertForm = () => {
  const methods = useForm<JoinOtpCertFormItemsType>({
    mode: 'onBlur',
    defaultValues: {
      pNumber: '',
      certNumber: '',
      agency: 0,
    },
  })
  const { setValue } = methods
  const pNumberOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('pNumber', NumReplace(event.target.value, 11), {
      shouldValidate: true,
      shouldTouch: true,
    })
  }
  const certNumberOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('certNumber', NumReplace(event.target.value, 4), {
      shouldValidate: true,
    })
  }
  const registerAttribute: Record<keyof JoinOtpCertFormItemsType, Partial<FormObjectType>> = {
    agency: {
      tag: 'agency',
      optionValueList: [
        { value: 0, text: 'SKT' },
        { value: 1, text: 'KT' },
        { value: 2, text: 'LG U+' },
      ],
    },
    pNumber: {
      placeholder: '휴대폰 번호 입력(- 없이)',
      type: 'tel',
      tag: 'pNumber',
      register_options: {
        required: '인증 완료 후 이용해주세요.',
        maxLength: { value: 11, message: '인증 완료 후 이용해주세요.' },
        validate: {
          elevenDigits: (v: string | undefined) =>
            (v ?? '').replace(/\D/g, '').length === 11 || '인증 완료 후 이용해주세요.',
        },
        pattern: { value: regExps.numReg.pattern, message: '패턴 틀림' },
        onChange: pNumberOnChangeHandler,
        inputmode: 'numeric',
      },
    },
    certNumber: {
      placeholder: '인증번호 입력',
      type: 'tel',
      tag: 'certNumber',
      register_options: {
        pattern: { value: regExps.numReg.pattern, message: '패턴 틀림' },
        minLength: { value: 1, message: '인증번호를 입력해주세요.' },
        onChange: certNumberOnChangeHandler,
        inputmode: 'numeric',
      },
    },
  }

  return {
    methods,
    registerAttribute,
  }
}
export default useOtpCertForm
